// Copyright 2020 TOKU Systems Inc.
import { Illumass, kuzzleParamsFromUrl } from '@equestria/spike';
import { Kuzzle, WebSocket } from 'kuzzle-sdk';

console.log(`API: ${process.env.REACT_APP_ILLUMASS_API_URL}`);
const [host, opts] = kuzzleParamsFromUrl(
  process.env.REACT_APP_ILLUMASS_API_URL ?? 'ws://localhost:7512'
);
const illumass = new Illumass(new Kuzzle(new WebSocket(host, opts)));
export default illumass;
